/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'


export const getAllKeyCloakUsers = createAsyncThunk('user/getAllKeyCloakUsers', async (params, { rejectWithValue }) => {
    try {
        const data = await api.keycloak.getKeycloakAllUsers(params);
        return Promise.resolve(data);

    } catch (error) {
        return rejectWithValue(error.message);
    }
})